module.exports = __webpack_public_path__ + "img/Group 106@2x.c0fe231d.png";